import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { catchError } from "rxjs/operators";
import { Helper } from "src/app/shared/helpers/helper";
import { BASE_BACKEND, ResponseData } from "src/app/shared/http/api";

@Injectable({
  providedIn: "root",
})
export class DashboardService {
  constructor(private http: HttpClient) {}

  openCloseSchedule(queryParams): Observable<ResponseData> {
    return this.http
      .get(`${BASE_BACKEND}dashboard/openCloseSchedule?${queryParams}`)
      .pipe(catchError(Helper.handleError));
  }
}
